import { Component } from '@angular/core';
import { AbstractAppComponent } from '@shared/components/abstracts/abstract-app.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent extends AbstractAppComponent {
  constructor() {
    super(
      `L'historique de votre véhicule en quelques clics`,
      `Assurez-vous de faire le bon choix et évitez les arnaques et les vices cachés avec des rapports d'historique de véhicules fiables et détaillés.`
    );
  }
}
